export default __webpack_public_path__ + "static/media/start_app.7699a785.svg";